import { render, staticRenderFns } from "./PriceUpdate.vue?vue&type=template&id=5e0ee3c3"
import script from "./PriceUpdate.vue?vue&type=script&lang=js"
export * from "./PriceUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports